<i18n>
{
  "fr": {
    "attachementTitle": "Liste des pièces jointes"
  }
}
</i18n>

<template>
  <div :class="[withouPanel ? '' :'panel panel-info', 'pb-20 mg-t-15']">
    <div :class="[withouPanel ? '' :'panel-heading']">
      <a v-on:click=" collapsed = !collapsed" class="collapse-link">
        <h3 :class="[withouPanel ? 'header-title' :'']" v-b-toggle="'collapse_1' + indexCol">
          {{ $t('attachementTitle')}}
          <i
            :class="[collapsed ? 'fa-chevron-down' : 'fa-chevron-up', 'fa']"
          ></i>
        </h3>
      </a>
    </div>
    <b-collapse :id="'collapse_1' + indexCol" class="mt-2">
      <b-card>
        <div :class="[withouPanel ? '' :'panel-body']">
          <b-form-group label="Photos" label-for="photos" label-cols="5">
            <vue-dropzone ref="photos" id="dropzone" name="photos" :options="dropzoneOptions"></vue-dropzone>
          </b-form-group>
          <b-form-group label="Schémas" label-for="schema" label-cols="5">
            <vue-dropzone ref="schemas" id="dropzone" name="schema" :options="dropzoneOptions"></vue-dropzone>
          </b-form-group>
          <b-form-group label="Documents techniques" label-for="technicalFiles" label-cols="5">
            <vue-dropzone
              ref="technicalFiles"
              id="dropzone"
              name="technicalFiles"
              :options="dropzoneOptions"
            ></vue-dropzone>
          </b-form-group>
          <b-form-group label="Comptes rendus" label-for="report" label-cols="5">
            <vue-dropzone ref="reports" id="dropzone" name="report" :options="dropzoneOptions"></vue-dropzone>
          </b-form-group>
          <b-form-group label="Autres" label-for="other" label-cols="5">
            <vue-dropzone ref="others" id="dropzone" name="other" :options="dropzoneOptions"></vue-dropzone>
          </b-form-group>
        </div>
      </b-card>
    </b-collapse>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { getEndpoint } from '../store/endpoints';

// This is a description of the component
export default {
  name: 'Dropzone',
  props: {
    // The 'withouPanel' is a boolean
    withouPanel: { type: Boolean, default: false },
    indexCol: { type: Number },
  },
  components: {
    //Dropzone use library vue2Dropzone
    vueDropzone: vue2Dropzone,
  },
  data: () => ({
    collapsed: { type: Boolean, default: false },
    dropzoneOptions: {
      url: '/post', //required but unused
      thumbnailWidth: 90,
      thumbnailHeight: 90,
      maxFiles: 5,
      maxFilesize: 250,
      addRemoveLinks: true,
      uploadMultiple: true,
      autoProcessQueue: false,
      dictDefaultMessage: `<i class='fa fa-cloud-upload'></i> Déposer des fichiers ici pour télécharger`,
      dictRemoveFile: 'Supprimer',
      dictMaxFilesExceeded: 'Vous ne pouvez pas télécharger ce fichier',
    },

  }),
  mounted () {
    let dropzoneRefs = [
      'photos',
      'schemas',
      'technicalFiles',
      'reports',
      'others',
    ];

    dropzoneRefs.forEach(ref => {
      this.setDropzoneDownloadUrl(ref);
    });
  },
  methods: {
    setDropzoneDownloadUrl(ref) {
      let _this = this;

      this.$refs[ref].dropzone.on('addedfile', function (file) {
        if (typeof file.id !== 'undefined') {
          var a = document.createElement('a');
          a.setAttribute('href', _this.getAbsoluteDownloadUrl(file));
          a.setAttribute('target', '_blank');
          a.setAttribute('class', 'dz-download');
          a.innerHTML = "Télécharger";
          file.previewTemplate.appendChild(a);
        }
      });
    },
    getAbsoluteDownloadUrl(file) {
      let endpoint = null;

      if (typeof this.$route.params.controlId !== "undefined") {
        
        endpoint = getEndpoint('file', null, this.$route.params.controlId, file.id).absoluteDownloadUrl;
      }else{
        if (typeof this.$route.params.propertyId !== "undefined") {
          endpoint = getEndpoint('properties', this.$route.params.propertyId,null , file.id).absoluteDownloadUrl;
        }
      }
      return endpoint;
    },
  },
};
</script>
